import { faSitemap, faUser } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tab, Tabs, Typography } from "@mui/material"
import { MyAgencyPage } from "agency/components/MyAgencyPage"
import { translate } from "app/language/service"
import { NotificationPage } from "notification/components/NotificationPage"
import { NotFoundPage } from "page/components/NotFoundPage"
import { SETTINGS_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { useParams } from "react-router-dom"
import { FlexBox } from "ui/components/FlexBox"
import { PageHeader } from "ui/components/main-layout/PageHeader"
import { ALL_SETTINGS_PAGES, SETTINGS_PAGES } from "ui/model"
import { addImportant } from "ui/tools/common"
import { MyProfilePage } from "user/components/MyProfilePage"
import { AppVersion } from "../AppVersion"

export const SettingsPage = React.memo((): JSX.Element => {
  const { pageId } = useParams()
  const activePage: SETTINGS_PAGES = pageId as SETTINGS_PAGES
  if (!ALL_SETTINGS_PAGES.includes(pageId as SETTINGS_PAGES)) {
    return <NotFoundPage />
  }
  return (
    <FlexBox
      vertical
      fullWidth
      fullHeight
      ai="start"
      jc="start"
      sx={{ position: "relative", animation: "fadeIn 600ms" }}>
      <PageHeader title={translate("settings.page.title")} />
      <AppVersion sx={{ position: "absolute", top: "1.45rem", right: "1rem" }} />
      <FlexBox
        fullWidth
        jc="start"
        ai="start"
        vertical
        sx={{
          pt: 0,
          height: "calc(100% - 5rem)"
        }}>
        <Tabs
          value={activePage}
          onChange={(_event, newTab: SETTINGS_PAGES) => {
            navigate({ path: SETTINGS_PATH, pathParams: newTab })
          }}
          sx={{
            "ml": "2rem",
            "mr": "2rem",
            "width": "calc(100% - 4rem)",
            "maxWidth": "calc(100% - 4rem)",
            "borderBottom": theme => theme.palette.border,
            "& .MuiButtonBase-root.MuiTab-root.Mui-selected p": {
              color: theme => theme.palette.text.primary2,
              fontWeight: 500
            },
            "& .MuiButtonBase-root.MuiTab-root": {
              fontWeight: 300,
              minWidth: "11rem"
            },
            "@media (max-width: 1300px)": {
              "& .MuiButtonBase-root.MuiTab-root": {
                minWidth: "auto"
              }
            },
            "& .MuiTabs-scrollButtons svg": {
              color: theme => theme.palette.text.primary2
            }
          }}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile>
          <Tab
            id="settings-tab-profile"
            value="profile"
            label={
              <FlexBox gap="1rem" sx={{ position: "relative" }}>
                <FontAwesomeIcon icon={faUser} size="lg" />
                <Typography
                  sx={{
                    color: theme => addImportant(theme.palette.text.primary2 as string)
                  }}>
                  {translate("label.profile")}
                </Typography>
              </FlexBox>
            }
          />
          <Tab
            id="settings-tab-agency"
            value="agency"
            label={
              <FlexBox gap="1rem" sx={{ position: "relative" }}>
                <FontAwesomeIcon icon={faSitemap} size="lg" />
                <Typography
                  sx={{
                    color: theme => addImportant(theme.palette.text.primary2 as string)
                  }}>
                  {translate("label.agency")}
                </Typography>
              </FlexBox>
            }
          />
          {/* <Tab
            value={"notification"}
            label={
              <FlexBox gap="1rem" sx={{ position: "relative" }}>
                <FontAwesomeIcon icon={regular("bell")} size="lg" />
                <Typography
                  sx={{
                    color: theme => addImportant(theme.palette.text.primary2 as string)
                  }}>
                  {translate("label.notifications")}
                </Typography>
              </FlexBox>
            }
          />*/}
        </Tabs>
        <FlexBox
          fullWidth
          vertical
          gap
          sx={{
            overflow: "auto",
            height: "calc(100% - 3rem)",
            minHeight: "calc(100% - 3rem)",
            maxHeight: "calc(100% - 3rem)"
          }}>
          {activePage === "agency" ? (
            <MyAgencyPage />
          ) : activePage === "notification" ? (
            <NotificationPage />
          ) : (
            <MyProfilePage />
          )}
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
})
